import router from "@/router";
import axiosInstance from "@/composables/axios-instance";
import VueCookies from "vue-cookies";
import axios from "axios";
// import toast from "vue3-toastify";

const state = {
    isAuthenticated: false,
    userName: '',
};

const getters = {
    getIsAuthenticated(state){
        return state.isAuthenticated;
    },
};

const mutations = {
    setAccessAndRefreshToken(state,tokens){
        state.isAuthenticated = true;
        VueCookies.set("ACCESS-TOKEN", tokens.access_token, tokens.expires_in);
        VueCookies.set("TOKEN-TYPE", tokens.token_type)
        VueCookies.set(
          "__INVENTORY-REFRESH-TOKEN",
          tokens.refresh_token,
          null,
          null,
          null,
          true,
          "Strict"
        );
    },
    setIsAuthenticated(state){
        state.isAuthenticated = true;
    },
};

const actions = {
    isAuthenticated() {
        return axiosInstance.get('/auth/').then(response=>{
            window.location.assign(response.data.auth_url);
        }).catch(error=>{
            console.error(error);
        })
    },
    getAccessAndRefreshToken({commit}){
        return axiosInstance.get('/callback/', {
            params:{
                code: router.currentRoute.value.query.code,
                state: router.currentRoute.value.query.state
        }}).then(response=>{
            commit('setAccessAndRefreshToken', response.data);
            router.push({name:'dashboard'});
        }).catch(error=>{
            console.error(error)
        })
    },
    getAccessTokenFromRefreshToken({commit}){
        return axios.get('/refresh/', {params: {
            refresh_token:  VueCookies.get("__INVENTORY-REFRESH-TOKEN")
        }}).then(response=>{
            commit("setAccessAndRefreshToken", response.data);
        }).catch(error=>{
            console.error(error);
            VueCookies.remove("__INVENTORY-REFRESH-TOKEN");
            VueCookies.remove("ACCESS-TOKEN");
            router.push({name: 'login'});
        })
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}